module.exports = {
  label: {
    headerTitle: 'Visitor Request',
    groupName: 'Group Name',
    selectDate: 'Select Date',
    addHeaderTitle: 'View Visitor Request',
    siteName: 'Site Name',
    visitorName: 'Visitor Name',
    accessDate: 'Access Date',
    fromDateRange: 'From Date',
    toDateRange: 'To Date',
    hostUserName: 'Department Name',
    visitorRemarks: 'Visitor Remarks',
    approvedBy: 'Approved By',
    questions: 'Questions',
    siteRemarks: 'Site Remarks',
    action: 'Action',
    documents: 'Documents',
    search: 'Search...',
    noData:'---',
    status:'Status',
    idPassport:'ID/Passport',
    vistitorSurname:'Visitor Surname',
    mobileNo:'Mobile Number',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      view: 'View',
      approve: 'Approve'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel',
      accept: 'Accept',
      filter: 'Filter',
      decline: 'Decline'
    }
  }
}
